module.exports = __webpack_public_path__ + "img/yhgh3.745c504a.png";